/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { CategoryHierarchy } from '@msdyn365-commerce/commerce-entities';
import * as React from 'react';
import { IDobbiesBrowseViewProps } from './dobbies-browse';
import MsDyn365, * as Msdyn365 from '@msdyn365-commerce/core';
// import Button from 'reactstrap/lib/Button';
import { ISubMenuStaticMenusData } from '../dobbies-navigation-menu/dobbies-navigation-menu.props.autogenerated';
import { getLocalStorage } from '../../themes/dobbies/utilities/storage';

const renderLinks = (category: CategoryHierarchy, props: IDobbiesBrowseViewProps): JSX.Element => {
    const recordId = props.context.request.urlTokens.recordId;
    const activeClass = recordId && +recordId === category.RecordId ? 'browse-active-link' : '';
    return (
        <>
            {category.Name && (
                <a key={category.RecordId} href={category.Url} className={`category-pill ${activeClass} `}>
                    {category.Name}
                </a>
            )}
        </>
    );
};

const shouldCategoryHide = (props: IDobbiesBrowseViewProps, neutralizedName?: string): boolean => {
    if (props.config.hideMenuItemPrefix && neutralizedName?.startsWith(props.config.hideMenuItemPrefix)) {
        return true;
    }
    return false;
};

const _getScreenSize = (ctx: Msdyn365.ICoreContext): number => {
    // always render in mobile viewport on a mobile device
    // if (ctx.request && ctx.request.device && ctx.request.device.Type === 'Mobile') {
    //     return 1;
    // }

    if ((MsDyn365.isBrowser && window) !== undefined && MsDyn365.isBrowser && window && window.innerWidth) {
        const gridSettings = ctx.request.gridSettings;
        if (gridSettings) {
            // if (gridSettings.xs && (MsDyn365.isBrowser && window && window.innerWidth) < gridSettings.xs.w) {
            if (gridSettings.xs && (MsDyn365.isBrowser && window && window.innerWidth) < 700) {
                // mobile
                return 1;
            } else if (window.innerWidth >= 700 && window.innerWidth < 1250) {
                // else if (gridSettings.sm && (MsDyn365.isBrowser && window && window.innerWidth) <= gridSettings.sm.w) {
                // iPad
                return 2;
            } else if (window.innerWidth >= 1250 && window.innerWidth < 1700) {
                // else if (gridSettings.md && (MsDyn365.isBrowser && window && window.innerWidth) <= gridSettings.md.w) {
                // Desktop
                return 3;
            } else if (window.innerWidth >= 1700) {
                // Desktop
                return 3;
            } else {
                return 3;
            }
        }
    }

    return 3; // desktop
};

/* VSI-Customization -- START
Will render "View All" link and append the direct children of root link (children links based on rootLink(category ID))
*/

// const showRemainingCategories = () => {
//     const moreOptionsDiv = document.getElementById('more-cats-div');
//     if (moreOptionsDiv) {
//         if (moreOptionsDiv.classList.contains('show-more-option')) {
//             moreOptionsDiv.classList.remove('show-more-option');
//             moreOptionsDiv.classList.add('hide-more-option');
//         } else {
//             moreOptionsDiv.classList.remove('hide-more-option');
//             moreOptionsDiv.classList.add('show-more-option');
//         }
//     }
// };

const renderRootLink = (
    categories: JSX.Element[],
    category: CategoryHierarchy,
    makeActive: boolean,
    screenSize: number,
    showMore: boolean,
    maxCategoriesToBeShown: number
): JSX.Element[] => {
    // if (screenSize === 1 && showMore) {
    //     return [
    //         // ...categories.slice(0, 2),
    //         <li key={categories.length} className='more-subcategories-child'>
    //             <Button
    //                 className='more-subcategories'
    //                 href=''
    //                 key={categories.length}
    //                 onClick={() => {
    //                     showRemainingCategories();
    //                 }}
    //             >
    //                 {/* more options */}
    //                 Categories
    //             </Button>
    //             <ul id='more-cats-div' className='hide-more-option'>
    //                 {/* {categories.splice(2, categories.length)} */}
    //                 {categories}
    //             </ul>
    //         </li>
    //     ];
    // } else if (screenSize === 2 && showMore) {
    //     if (categories.length === maxCategoriesToBeShown + 1) {
    //         return [...categories];
    //     }
    //     return [
    //         ...categories.slice(0, maxCategoriesToBeShown),
    //         <li key={categories.length} className='more-subcategories-child'>
    //             <Button
    //                 className='more-subcategories'
    //                 href=''
    //                 key={categories.length}
    //                 onClick={() => {
    //                     showRemainingCategories();
    //                 }}
    //             >
    //                 more options
    //             </Button>
    //             <ul id='more-cats-div' className='hide-more-option'>
    //                 {categories.splice(maxCategoriesToBeShown, categories.length)}
    //             </ul>
    //         </li>
    //     ];
    // } else if (screenSize === 3 && showMore) {
    //     if (categories.length === maxCategoriesToBeShown + 1) {
    //         return [...categories];
    //     }
    //     return [
    //         ...categories.slice(0, maxCategoriesToBeShown),
    //         <li key={categories.length} className='more-subcategories-child'>
    //             <Button
    //                 className='more-subcategories'
    //                 href=''
    //                 key={categories.length}
    //                 onClick={() => {
    //                     showRemainingCategories();
    //                 }}
    //             >
    //                 more options
    //             </Button>
    //             <ul id='more-cats-div' className='hide-more-option'>
    //                 {categories.splice(maxCategoriesToBeShown, categories.length)}
    //             </ul>
    //         </li>
    //     ];
    // }
    return [...categories];
};

const getMaxCategoriesForCurrentScreenSize = () => {
    if ((MsDyn365.isBrowser && window) !== undefined && MsDyn365.isBrowser && window && window.innerWidth) {
        if (window.innerWidth >= 1700) {
            return 4;
        } else if (window.innerWidth >= 1250 && window.innerWidth < 1700) {
            return 3;
        } else if (window.innerWidth >= 700 && window.innerWidth < 1250) {
            return 2;
        } else if (window.innerWidth < 700) {
            return 1;
        }
    }
    return 4;
};

const getStaticCategories = (props: IDobbiesBrowseViewProps, results: CategoryHierarchy[] | undefined) => {
    const staticMenusLS = getLocalStorage('static_submenu_items');
    let staticMenuJSONObj;
    if (staticMenusLS) {
        staticMenuJSONObj = JSON.parse(staticMenusLS);
    }
    let staticMenus: ISubMenuStaticMenusData[] = [];
    const staticCategories: CategoryHierarchy[] = [];
    if (Array.isArray(staticMenuJSONObj)) {
        staticMenus = staticMenuJSONObj as ISubMenuStaticMenusData[];
    }
    if (results && results.length) {
        const lastCategory = results[results.length - 1];
        staticMenus = staticMenus.filter(sm => sm.linkText === lastCategory.Name && sm.subMenus?.length);
        staticMenus.map(sm => {
            sm.subMenus?.map(sbm => {
                const c: CategoryHierarchy = { Name: sbm.linkText, Url: sbm.linkUrl.destinationUrl, Children: [], RecordId: -1 };
                staticCategories.push(c);
            });
        });
    }
    return staticCategories;
};

const replaceCategory = (props: IDobbiesBrowseViewProps, category: CategoryHierarchy): CategoryHierarchy => {
    if (props.config.categoriesReplacementPriorityList && props.config.categoriesReplacementPriorityList.length) {
        for (const replacementInfo of props.config.categoriesReplacementPriorityList) {
            if (replacementInfo.categoryToBeReplaced === category.Name) {
                category.Name = replacementInfo.replacingCategory;
                category.Url = replacementInfo.replacingCategoryUrl;
                return category;
            }
        }
    }
    return category;
};

/* VSI-Customization -- END  */

/* VSI-Customization -- START Will render the categories based on selection  */
const renderCategories = (props: IDobbiesBrowseViewProps): JSX.Element[][] | JSX.Element[] | undefined => {
    const results = props.data.categoryHierarchy.result;
    const [showMoreOptions, setShowMoreOptions] = React.useState(false);
    const screenSize = _getScreenSize(props.context);
    if (props.maxNumberOfCategoriesForScreenSize === -1) {
        return [];
    }
    let maxCategoriesToBeShown = props.maxNumberOfCategoriesForScreenSize
        ? props.maxNumberOfCategoriesForScreenSize
        : getMaxCategoriesForCurrentScreenSize(); // screenSize === 1 || screenSize === 2 ? 3 : 4;
    const originalMaxCategoriesToBeShown = props.maxNumberOfCategoriesForScreenSize
        ? props.maxNumberOfCategoriesForScreenSize
        : getMaxCategoriesForCurrentScreenSize(); // screenSize === 1 || screenSize === 2 ? 3 : 4;
    const characterLimit = props.config.maximumCharacterLimit;
    /* VSI-Customization -- START
    Render categories if parent doesn't exist
    */
    let lengthCheckIter = 0;
    if (results && results.length === 1) {
        return results.map((cat: CategoryHierarchy) => {
            const staticCategories = getStaticCategories(props, results);
            const categories = cat.Children.filter(cat => !shouldCategoryHide(props, cat.NeutralizedName))
                .concat(staticCategories)
                .map(
                    (category: CategoryHierarchy): JSX.Element => {
                        if (
                            characterLimit &&
                            category?.Name?.length &&
                            category?.Name?.length >= characterLimit &&
                            lengthCheckIter < originalMaxCategoriesToBeShown &&
                            maxCategoriesToBeShown >= originalMaxCategoriesToBeShown
                        ) {
                            maxCategoriesToBeShown = maxCategoriesToBeShown - 1;
                        }
                        lengthCheckIter++;
                        category = replaceCategory(props, category);
                        return renderLinks(category, props);
                    }
                );
            const totalCategories = categories?.length ? categories.length : 0;

            if (screenSize === 1) {
                if (totalCategories > maxCategoriesToBeShown && !showMoreOptions) {
                    setShowMoreOptions(true);
                }
            }
            if (screenSize === 2) {
                if (totalCategories > maxCategoriesToBeShown && !showMoreOptions) {
                    setShowMoreOptions(true);
                }
            } else if (screenSize === 3) {
                if (totalCategories > maxCategoriesToBeShown && !showMoreOptions) {
                    setShowMoreOptions(true);
                }
            }
            return renderRootLink(categories, cat, true, screenSize, showMoreOptions, maxCategoriesToBeShown);
        });
    }
    /* VSI-Customization -- END  */

    /* VSI-Customization -- START
    Render Direct childrens of some category ID that has children categories
    */
    if (results && results.length === 2) {
        if (results[1].Children && results[1].Children.length > 0) {
            const staticCategories = getStaticCategories(props, [results[1]]);
            const categories = results[1].Children.filter(cat => !shouldCategoryHide(props, cat.NeutralizedName))
                .concat(staticCategories)
                .map(
                    (category: CategoryHierarchy): JSX.Element => {
                        if (
                            characterLimit &&
                            category?.Name?.length &&
                            category?.Name?.length >= characterLimit &&
                            lengthCheckIter < originalMaxCategoriesToBeShown &&
                            maxCategoriesToBeShown >= originalMaxCategoriesToBeShown
                        ) {
                            maxCategoriesToBeShown = maxCategoriesToBeShown - 1;
                        }
                        lengthCheckIter++;
                        category = replaceCategory(props, category);
                        return renderLinks(category, props);
                    }
                );
            const totalCategories = categories?.length ? categories.length : 0;
            if (screenSize === 1) {
                if (totalCategories > maxCategoriesToBeShown && !showMoreOptions) {
                    setShowMoreOptions(true);
                }
            }
            if (screenSize === 2) {
                if (totalCategories > maxCategoriesToBeShown && !showMoreOptions) {
                    setShowMoreOptions(true);
                }
            } else if (screenSize === 3) {
                if (totalCategories > maxCategoriesToBeShown && !showMoreOptions) {
                    setShowMoreOptions(true);
                }
            }
            return renderRootLink(categories, results[1], true, screenSize, showMoreOptions, maxCategoriesToBeShown);
        } else {
            // VSI CUSTOMIZATION - START - Edits Further Customization
            const urlID = Number(
                props.context.request.url.requestUrl.href
                    .substring(props.context.request.url.requestUrl.href.lastIndexOf('/') + 1)
                    .split('.')[0]
            );
            const staticCategories = getStaticCategories(props, [results[0]]);
            // VSI CUSTOMIZATION - END - Edits Further Customization
            const categories = results[0].Children.filter(cat => cat.RecordId !== urlID)
                .filter(cat => !shouldCategoryHide(props, cat.NeutralizedName))
                .concat(staticCategories)
                .map(
                    (category: CategoryHierarchy): JSX.Element => {
                        // VSI CUSTOMIZATION - START - Edits Further Customization
                        // if (category.RecordId === urlID) {
                        //     return renderLinks(category, props);
                        // } else {
                        //     return <div style={{ display: 'none' }} key={''}></div>;
                        // }
                        if (
                            characterLimit &&
                            category?.Name?.length &&
                            category?.Name?.length >= characterLimit &&
                            lengthCheckIter < originalMaxCategoriesToBeShown &&
                            maxCategoriesToBeShown >= originalMaxCategoriesToBeShown
                        ) {
                            maxCategoriesToBeShown = maxCategoriesToBeShown - 1;
                        }
                        lengthCheckIter++;
                        category = replaceCategory(props, category);
                        return renderLinks(category, props);
                        // VSI CUSTOMIZATION - END - Edits Further Customization
                    }
                );
            const totalCategories = categories?.length ? categories.length : 0;
            if (screenSize === 1) {
                if (totalCategories > maxCategoriesToBeShown && !showMoreOptions) {
                    setShowMoreOptions(true);
                }
            }
            if (screenSize === 2) {
                if (totalCategories > maxCategoriesToBeShown && !showMoreOptions) {
                    setShowMoreOptions(true);
                }
            } else if (screenSize === 3) {
                if (totalCategories > maxCategoriesToBeShown && !showMoreOptions) {
                    setShowMoreOptions(true);
                }
            }
            return renderRootLink(categories, results[0], false, screenSize, showMoreOptions, maxCategoriesToBeShown);
        }
    }

    if (results && results.length === 3) {
        if (results[2].Children && results[2].Children.filter(cat => !shouldCategoryHide(props, cat.NeutralizedName)).length > 0) {
            const staticCategories = getStaticCategories(props, [results[2]]);
            const categories = results[2].Children.filter(cat => !shouldCategoryHide(props, cat.NeutralizedName))
                .concat(staticCategories)
                .map(
                    (category: CategoryHierarchy): JSX.Element => {
                        if (
                            characterLimit &&
                            category?.Name?.length &&
                            category?.Name?.length >= characterLimit &&
                            lengthCheckIter < originalMaxCategoriesToBeShown &&
                            maxCategoriesToBeShown >= originalMaxCategoriesToBeShown
                        ) {
                            maxCategoriesToBeShown = maxCategoriesToBeShown - 1;
                        }
                        lengthCheckIter++;
                        category = replaceCategory(props, category);
                        return renderLinks(category, props);
                    }
                );
            const totalCategories = categories?.length ? categories.length : 0;
            if (screenSize === 1) {
                if (totalCategories > maxCategoriesToBeShown && !showMoreOptions) {
                    setShowMoreOptions(true);
                }
            }
            if (screenSize === 2) {
                if (totalCategories > maxCategoriesToBeShown && !showMoreOptions) {
                    setShowMoreOptions(true);
                }
            } else if (screenSize === 3) {
                if (totalCategories > maxCategoriesToBeShown && !showMoreOptions) {
                    setShowMoreOptions(true);
                }
            }
            return renderRootLink(categories, results[2], true, screenSize, showMoreOptions, maxCategoriesToBeShown);
        } else {
            const urlID = Number(
                props.context.request.url.requestUrl.href
                    .substring(props.context.request.url.requestUrl.href.lastIndexOf('/') + 1)
                    .split('.')[0]
            );
            const staticCategories = getStaticCategories(props, [results[1]]);
            const categories = results[1].Children.filter(cat => cat.RecordId !== urlID)
                .filter(cat => !shouldCategoryHide(props, cat.NeutralizedName))
                .concat(staticCategories)
                .map(
                    (category: CategoryHierarchy): JSX.Element => {
                        if (
                            characterLimit &&
                            category?.Name?.length &&
                            category?.Name?.length >= characterLimit &&
                            lengthCheckIter < originalMaxCategoriesToBeShown &&
                            maxCategoriesToBeShown >= originalMaxCategoriesToBeShown
                        ) {
                            maxCategoriesToBeShown = maxCategoriesToBeShown - 1;
                        }
                        lengthCheckIter++;
                        category = replaceCategory(props, category);
                        return renderLinks(category, props);
                    }
                );
            const totalCategories = categories?.length ? categories.length : 0;
            if (screenSize === 1) {
                if (totalCategories > maxCategoriesToBeShown && !showMoreOptions) {
                    setShowMoreOptions(true);
                }
            }
            if (screenSize === 2) {
                if (totalCategories > maxCategoriesToBeShown && !showMoreOptions) {
                    setShowMoreOptions(true);
                }
            } else if (screenSize === 3) {
                if (totalCategories > maxCategoriesToBeShown && !showMoreOptions) {
                    setShowMoreOptions(true);
                }
            }
            return renderRootLink(categories, results[1], false, screenSize, showMoreOptions, maxCategoriesToBeShown);
        }
    }

    if (results && results.length === 4) {
        if (results[3].Children && results[3].Children.length > 0) {
            const staticCategories = getStaticCategories(props, [results[3]]);
            const categories = results[3].Children.filter(cat => !shouldCategoryHide(props, cat.NeutralizedName))
                .concat(staticCategories)
                .map(
                    (category: CategoryHierarchy): JSX.Element => {
                        if (
                            characterLimit &&
                            category?.Name?.length &&
                            category?.Name?.length >= characterLimit &&
                            lengthCheckIter < originalMaxCategoriesToBeShown &&
                            maxCategoriesToBeShown >= originalMaxCategoriesToBeShown
                        ) {
                            maxCategoriesToBeShown = maxCategoriesToBeShown - 1;
                        }
                        lengthCheckIter++;
                        category = replaceCategory(props, category);
                        return renderLinks(category, props);
                    }
                );
            const totalCategories = categories?.length ? categories.length : 0;
            if (screenSize === 1) {
                if (totalCategories > maxCategoriesToBeShown && !showMoreOptions) {
                    setShowMoreOptions(true);
                }
            }
            if (screenSize === 2) {
                if (totalCategories > maxCategoriesToBeShown && !showMoreOptions) {
                    setShowMoreOptions(true);
                }
            } else if (screenSize === 3) {
                if (totalCategories > maxCategoriesToBeShown && !showMoreOptions) {
                    setShowMoreOptions(true);
                }
            }
            return renderRootLink(categories, results[3], true, screenSize, showMoreOptions, maxCategoriesToBeShown);
        } else {
            const staticCategories = getStaticCategories(props, [results[2]]);
            const urlID = Number(
                props.context.request.url.requestUrl.href
                    .substring(props.context.request.url.requestUrl.href.lastIndexOf('/') + 1)
                    .split('.')[0]
            );
            const categories = results[2].Children.filter(cat => cat.RecordId !== urlID)
                .filter(cat => !shouldCategoryHide(props, cat.NeutralizedName))
                .concat(staticCategories)
                .map(
                    (category: CategoryHierarchy): JSX.Element => {
                        if (
                            characterLimit &&
                            category?.Name?.length &&
                            category?.Name?.length >= characterLimit &&
                            lengthCheckIter < originalMaxCategoriesToBeShown
                        ) {
                            maxCategoriesToBeShown = maxCategoriesToBeShown - 1;
                        }
                        lengthCheckIter++;
                        category = replaceCategory(props, category);
                        return renderLinks(category, props);
                    }
                );
            const totalCategories = categories?.length ? categories.length : 0;
            if (screenSize === 1) {
                if (totalCategories > maxCategoriesToBeShown && !showMoreOptions) {
                    setShowMoreOptions(true);
                }
            }
            if (screenSize === 2) {
                if (totalCategories > maxCategoriesToBeShown && !showMoreOptions) {
                    setShowMoreOptions(true);
                }
            } else if (screenSize === 3) {
                if (totalCategories > maxCategoriesToBeShown && !showMoreOptions) {
                    setShowMoreOptions(true);
                }
            }
            return renderRootLink(categories, results[2], false, screenSize, showMoreOptions, maxCategoriesToBeShown);
        }
    }

    return;
};
/* VSI-Customization -- END  *

/* VSI-Customization -- END  */

export default (props: IDobbiesBrowseViewProps) => {
    const scrollRef = React.useRef<HTMLDivElement>(null);

    const [isAtStart, setIsAtStart] = React.useState(true);
    const [isAtEnd, setIsAtEnd] = React.useState(false);

    const checkScrollPosition = () => {
        const el = scrollRef.current;
        if (!el) {
            return;
        }

        const atStart = el.scrollLeft <= 0;

        const atEnd = el.scrollWidth <= el.clientWidth || el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;

        setIsAtStart(atStart);
        setIsAtEnd(atEnd);
    };

    React.useEffect(() => {
        const el = scrollRef.current;
        if (!el) {
            return;
        }

        const update = () => checkScrollPosition();

        requestAnimationFrame(update);

        const timeout = setTimeout(update, 120);

        el.addEventListener('scroll', checkScrollPosition);
        window.addEventListener('resize', update);

        return () => {
            el.removeEventListener('scroll', checkScrollPosition);
            window.removeEventListener('resize', update);
            clearTimeout(timeout);
        };
    }, [props.data.categoryHierarchy.result]);

    const scroll = (direction: 'left' | 'right') => {
        if (!scrollRef.current) {
            return;
        }
        const container = scrollRef.current;
        const items = Array.from(container.querySelectorAll<HTMLElement>('.category-pill'));
        if (!items.length) {
            const fallbackAmount = container.clientWidth * 0.8;
            container.scrollBy({ left: direction === 'right' ? fallbackAmount : -fallbackAmount, behavior: 'smooth' });
            return;
        }

        const currentScroll = container.scrollLeft;

        const navButtonWidth = 28; // px
        const viewLeft = currentScroll + navButtonWidth + 1;
        let currentIndex = items.findIndex(item => item.offsetLeft <= viewLeft && item.offsetLeft + item.offsetWidth > viewLeft);

        if (currentIndex === -1) {
            currentIndex = items.findIndex(item => item.offsetLeft > viewLeft);
            if (currentIndex === -1) {
                currentIndex = items.length - 1;
            }
        }

        const targetIndex = direction === 'right' ? Math.min(items.length - 1, currentIndex + 1) : Math.max(0, currentIndex - 1);
        if (direction === 'left' && targetIndex === 0) {
            container.scrollTo({ left: 0, behavior: 'smooth' });
            return;
        }

        const targetItem = items[targetIndex];
        let targetScrollLeft = targetItem.offsetLeft - navButtonWidth;
        if (targetScrollLeft < 0) {
            targetScrollLeft = 0;
        }
        container.scrollTo({ left: targetScrollLeft, behavior: 'smooth' });
    };

    const categories = renderCategories(props);
    const flatCategories = Array.isArray(categories) ? categories.flat() : categories;
    const hasCategories = !!flatCategories?.length;
    return (
        <div className={`category-slider-wrapper${!hasCategories ? ' d-none' : ''}`}>
            <button className={`nav-btn left ${isAtStart ? 'disabled' : ''}`} onClick={() => scroll('left')} disabled={isAtStart}>
                left
            </button>

            <div className='category-slider' ref={scrollRef}>
                {renderCategories(props)}
            </div>
            <button className={`nav-btn right ${isAtEnd ? 'disabled' : ''}`} onClick={() => scroll('right')} disabled={isAtEnd}>
                right
            </button>
        </div>
    );
};
